import { Link } from 'react-router-dom'
import { appUrl } from '@astro/config'

export default function PoojaCtaSection() {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="relative overflow-hidden rounded-[3rem] bg-[#140608] text-white border border-white/10 shadow-2xl px-8 py-14 md:px-16 md:py-16 text-center">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute left-1/2 top-0 w-125 h-125 -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.12)_0%,transparent_70%)] blur-3xl"></div>
          </div>

          <div className="relative z-10 mx-auto max-w-2xl space-y-6">
            <span className="text-4xl text-secondary">ॐ</span>
            <h2 className="font-heading text-3xl md:text-4xl uppercase leading-tight text-[#FBF3E4]">
              Every Order Leaves <span className="text-gradient-gold font-bold block">Blessed &amp; Energized</span>
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-white/60">
              You never need to arrange the ritual yourself — every gemstone, rudraksha and yantra from the Divine Shop undergoes Vedic pooja by our master priests before dispatch. For a stone chosen to your birth chart, consult Maharaj Ji first.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
              <Link
                to="/products"
                className="group inline-flex items-center justify-center whitespace-nowrap py-3.5 px-10 rounded-2xl bg-secondary text-white font-semibold uppercase tracking-widest text-[11px] shadow-lg shadow-secondary/20 transition-all hover:bg-white hover:text-primary active:scale-95"
              >
                Explore Energized Products <i className="fa-solid fa-arrow-right ml-3 transition-transform group-hover:translate-x-1"></i>
              </Link>
              <a
                href={appUrl('jyotish', 'consultations')}
                className="inline-flex items-center justify-center whitespace-nowrap py-3.5 px-10 rounded-2xl border border-goldPrimary/40 text-[#FBF3E4] font-semibold uppercase tracking-widest text-[11px] transition-all hover:border-goldPrimary hover:text-goldPrimary active:scale-95"
              >
                Book a Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
